const ApiUrl = `${process.env.VUE_APP_API_PP_CIUDADANO}`
const ApiCoreUrl = `${process.env.VUE_APP_API_PP_CORE}`

import axios from '@/interceptor-core'

export const requestReclamosMixin = {
  methods: {
    listaProblemasReclamos() {
      return axios.post(`${ApiUrl}/reclamos/problemas/lista`)
    },
    crearReclamo(body) {
      return axios.post(`${ApiUrl}/reclamos/crear`, body);
    },
    listaSolicitudesReclamos() {
      return axios.post(`${ApiUrl}/reclamos/lista`);/**/
    },
    getTerritorio(body = {}) {
      return axios.post(`${ApiCoreUrl}/territorio`, body);
    },
    getReclamoValidate() {
      return axios.post(`${ApiUrl}/reclamos/verificar/pendiente`);
    },
    getReclaimView(id) {
      const body = {
        id: id
      }
      return axios.post(`${ApiUrl}/reclamos/ver`, body)
    },
  }
};
